import type { StripeGetCustomersResponse } from '@weft/api-definition';
import { getPrivateApi } from 'apps/app/src/services/api';
import { useQuery } from 'react-query';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useStripeCustomers(options?: CustomUseQueryOptions<StripeGetCustomersResponse>) {
  return useQuery(
    ['stripeCustomers'],
    () => {
      const api = getPrivateApi();

      return api.stripeGetCustomers();
    },
    {
      ...options,
    },
  );
}
